export function accordeon(d) {
	if (!d.querySelector('.accordion-wrapper')) return;
	
	// Iterate over each accordion wrapper separately
	d.querySelectorAll('.accordion-wrapper').forEach(function(wrapper) {
		// Store the original image source for this wrapper
		const imageSection = wrapper.querySelector('.image-section .image-wrapper') || d.querySelector('.image-section .image-wrapper');
		let originalImgSrc = '';
		let originalPicture = null;
		
		if (imageSection && imageSection.querySelector('picture')) {
			originalPicture = imageSection.querySelector('picture');
			// Clone the original picture element to restore it later
			originalPicture = originalPicture.cloneNode(true);
		}
		
		// Create and store timelines for all boxes in this wrapper
		const boxTimelines = new Map();
		const boxes = wrapper.querySelectorAll('.box');
		
		boxes.forEach(function (el, indice, array) {
			let timeline = createTimeline(el);
			// Store timeline for future reference
			boxTimelines.set(el, timeline);
			
			let moreInfo = el.querySelector('.title');
			moreInfo.addEventListener('click', e => {
				e.preventDefault();
				const currentBox = moreInfo.closest(".box");

				if (!moreInfo.closest(".box").classList.contains('open')) {
					// Close all other open boxes first (only within this wrapper)
					closeAllBoxesExcept(wrapper, el, boxTimelines);
					
					// Open the clicked box
					moreInfo.closest(".box").classList.add('open');
					timeline.restart();
					
					// Replace the image if data-image is present
					const dataImage = el.getAttribute('data-image');
					if (dataImage && imageSection) {
						fadeImage(imageSection, dataImage);
					}
				} else {
					// If there's only one box, don't allow closing it
					if (boxes.length === 1) {
						return;
					}
					
					moreInfo.closest(".box").classList.remove('open');
					timeline.reverse();
					
					// Check if all boxes are closed and restore original image
					setTimeout(() => {
						const anyOpen = wrapper.querySelector('.box.open');
						if (!anyOpen && originalPicture) {
							restoreOriginalImage(imageSection, originalPicture);
						}
					}, 50);
				}
			});
		});
		
		// Open the first box by default
		if (boxes.length > 0) {
			const firstBox = boxes[0];
			const firstTimeline = boxTimelines.get(firstBox);
			
			firstBox.classList.add('open');
			if (firstTimeline) {
				firstTimeline.restart();
			}
			
			// Set the image for the first box if it has data-image
			const firstDataImage = firstBox.getAttribute('data-image');
			if (firstDataImage && imageSection) {
				fadeImage(imageSection, firstDataImage);
			}
		}
	});
}

// Function to close all boxes except the one being opened (only within the same wrapper)
function closeAllBoxesExcept(wrapper, currentBox, boxTimelines) {
	wrapper.querySelectorAll('.box.open').forEach(openBox => {
		if (openBox !== currentBox) {
			openBox.classList.remove('open');
			
			// Get the stored timeline for this box
			const timeline = boxTimelines.get(openBox);
			if (timeline) {
				timeline.reverse();
			}
		}
	});
}

// Function to fade images
function fadeImage(imageSection, newSrc) {
	const pictureElement = imageSection.querySelector('picture');
	if (!pictureElement) return;
	
	// Fade out current picture
	gsap.to(pictureElement, {
		opacity: 0,
		duration: 0.4,
		onComplete: () => {
			// Change source for all source elements
			const sourceElements = pictureElement.querySelectorAll('source');
			sourceElements.forEach(source => {
				source.setAttribute('data-srcset', newSrc);
				source.setAttribute('srcset', newSrc);
			});
			
			// Change source for img element
			const imgElement = pictureElement.querySelector('img');
			if (imgElement) {
				imgElement.setAttribute('data-src', newSrc);
				imgElement.setAttribute('src', newSrc);
			}
			
			// Fade in picture
			gsap.to(pictureElement, {
				opacity: 1,
				duration: 0.4
			});
		}
	});
}

// Function to restore original image
function restoreOriginalImage(imageSection, originalPicture) {
	const currentPicture = imageSection.querySelector('picture');
	if (!currentPicture || !originalPicture) return;
	
	// Fade out current picture
	gsap.to(currentPicture, {
		opacity: 0,
		duration: 0,
		onComplete: () => {
			// Replace with original picture
			const clonedOriginal = originalPicture.cloneNode(true);
			imageSection.replaceChild(clonedOriginal, currentPicture);
			
			// Fade in original picture
			gsap.to(clonedOriginal, {
				opacity: 1,
				duration: 0.3
			});
		}
	});
}

function createTimeline(el) {
	const hidden = el.querySelector('.hidden-box');
	const close = el.querySelector('.title span');
	

	const t = gsap.timeline();

	t.to(hidden, {
		height: 'auto',
		duration: 0.6,
		ease: 'power3.inOut',
	});
	t.to(
		close,
		{
			rotation: '+=180',
			duration: 0.6,
			ease: 'power3.inOut',
			onComplete: () => {
				
			},
		},
		'<'
	);

	t.pause();
	return t;
}
